import React from "react";
import SwitchCard from "./SwitchComponent";
import SensorCard from "./sensorDevice";
import ControllerCard from "./ControllerDevice";
import { SecurityDeviceCard } from "./SecurityDevice";
import EnergyMeterCard from "./EnergyMeterDevice";
import { CARD_KINDS, cardKindOf } from "../../constants/devices";

// Picks the card for a device from its type, as the app does.
const DeviceCard = ({ device }) => {
  switch (cardKindOf(device)) {
    case CARD_KINDS.SENSOR:
      return <SensorCard props={device} />;
    case CARD_KINDS.CONTROLLER:
      return <ControllerCard props={device} />;
    case CARD_KINDS.SECURITY:
      return <SecurityDeviceCard props={device} />;
    case CARD_KINDS.ENERGY:
      return <EnergyMeterCard props={device} />;
    default:
      return <SwitchCard props={device} />;
  }
};

// Placeholder cards while devices load.
export const CardSkeletons = ({ count = 3 }) =>
  Array.from({ length: count }, (_, index) => <div key={index} className="hx-skel" aria-hidden="true" />);

export default DeviceCard;
